import { arrayToObjWithValues, isNumeric } from 'Utils';

export default class StaticBuilderFormattedFields {
  constructor(sectionContent) {
    // Each of formattedFields should look something like:
    // {
    //   field: {},
    //   fields: [ field1, ...],
    //   isMultiple: boolean,
    //   isEndOfMultiple: boolean,
    // }
    this.formattedFields = [];
    this.sectionContent = sectionContent;
    this.currentFieldNumber = null;
  }

  getAllFormattedFields() {
    return this.formattedFields;
  }

  setupFieldInitialValue(field) {
    const updatedField = {
      ...field,
    };

    if (field.type === 'select_multiple') {
      let initialValuesArray = [];

      // if the field has content, then our api (php) correctly returns json
      try {
        initialValuesArray = JSON.parse(this.sectionContent[field.id] || null) || [];
      } catch (error) {
        // otherwise it returns the string `--` which we can't parse.
        // So, when we can't parse the json we use the field value itself, `--`.
        initialValuesArray = [this.sectionContent[field.id]];
      }
      updatedField.initialValues = arrayToObjWithValues(
        initialValuesArray,
        true,
      );
    } else {
      updatedField.initialValue = this.sectionContent[field.id];
    }

    return updatedField;
  }

  // Since our product maps use numbers in the id of a field to determine
  // whether fields should be grouped (and order is important), we need to
  // iterate through them first to properly create the groups.
  addField(field, isEndOfMultiple = false) {
    const updatedField = this.setupFieldInitialValue(field);

    // We first check if an id ends in a number, if so, we create a group
    // and all immediete consecutive fields with ids that end with the same
    // number will be in the same group (if a field later in the array has
    // an id with the same number, but is not consecutive, it will be in a new separate group)
    const idDelimSeparated = updatedField.id.split('_');
    const lastFieldIdChar = idDelimSeparated[idDelimSeparated.length - 1];

    // Finally, we only include the option to 'add more fields' to a group if
    // the field that immediately follows the group does not end in a number
    // or if we are on the last field in the array
    if (isNumeric(lastFieldIdChar)) {
      this.addFieldMultiple(updatedField, lastFieldIdChar, isEndOfMultiple);
    } else {
      // reset currentFieldNumber since any fields afterwards that end in the same number
      // should not be grouped
      this.currentFieldNumber = null;
      if (this.formattedFields.length) {
        this.formattedFields[this.formattedFields.length - 1].isEndOfMultiple = true;
      }

      this.formattedFields.push({
        field: updatedField,
        isMultiple: false,
        isEndOfMultiple: true,
      });
    }
  }

  addFieldMultiple(updatedField, lastFieldIdChar, isEndOfMultiple) {
    if (this.currentFieldNumber === lastFieldIdChar) {
      this.formattedFields[this.formattedFields.length - 1].fields.push(updatedField);
      this.formattedFields[this.formattedFields.length - 1].isEndOfMultiple = isEndOfMultiple;
    } else {
      this.currentFieldNumber = lastFieldIdChar;
      this.formattedFields.push({
        fields: [updatedField],
        isMultiple: true,
        isEndOfMultiple,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/StaticBuilderFormattedFields.jsx